module.exports = function() {
  return new Worker(__webpack_public_path__ + "a3efe27f9feeac940f0c.worker.js");
};